import { Checkbox, Form, Input } from "antd";
import { Link } from "react-router-dom";

import Button from "@ui/form-controls/button";
import constants from "constants/constants";
import { PasswordRule, UserNameValidation } from "constants/promptRules";

import { useLogin } from "../../hooks/use-login";
import { getRememberedUsername } from "../../lib/auth-session";
import AuthFooter from "../auth-footer";
import AuthShell from "../auth-shell";
import TextField from "@ui/form-controls/text-field";

const {
  PAGE_ROUTES: { REQUEST_PASSWORD_RESET_ROUTE }
} = constants;

const LoginForm = () => {
  const { handleSubmit, loading, message } = useLogin();
  const rememberedUsername = getRememberedUsername();

  return (
    <AuthShell
      footer={<AuthFooter />}
      loading={loading}
      message={message}
      title="Login to your Account!"
    >
      <Form
        name="drs-login"
        initialValues={{
          username: rememberedUsername,
          remember: Boolean(rememberedUsername),
          password: ""
        }}
        onFinish={handleSubmit}
      >
        <Form.Item
          name="username"
          rules={UserNameValidation}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <TextField placeholder="Please enter username" size="lg" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[PasswordRule]}
          label="Enter password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <Input.Password
            placeholder="Please enter password"
            className="!h-11 [&_.ant-input]:placeholder:!text-xs"
          />
        </Form.Item>

        <Form.Item name="remember" noStyle valuePropName="checked">
          <Checkbox>
            <span className="text-text text-sm font-thin font-open-sans-semibold">Remember me</span>
          </Checkbox>
        </Form.Item>
        <Link to={REQUEST_PASSWORD_RESET_ROUTE}>reset password</Link>

        <Form.Item className="mt-5">
          <Button size="lg" variant="primary" htmlType="submit" className="w-full">
            Login
          </Button>
        </Form.Item>
      </Form>
    </AuthShell>
  );
};

export default LoginForm;
